import React, { useState } from "react";
import { motion } from "framer-motion";
import { FaArrowDown, FaArrowUp } from "react-icons/fa";
import { activitiesData } from "../../constant/constant";
import ProgressiveImage from "../ProgressiveImage";

const Activities = () => {
  const [expanded, setExpanded] = useState(false);
  const years = expanded ? activitiesData : activitiesData.slice(0, 1);

  const toggleExpanded = () => {
    const isCollapsing = expanded;
    setExpanded(!expanded);
    if (isCollapsing) {
      window.requestAnimationFrame(() =>
        document.getElementById("activity")?.scrollIntoView({
          behavior: window.matchMedia("(prefers-reduced-motion: reduce)")
            .matches
            ? "auto"
            : "smooth",
          block: "start",
        }),
      );
    }
  };

  return (
    <section id="activity" className="section journey-section">
      <div className="journey-heading">
        <div>
          <p className="eyebrow">A life in progress</p>
          <h2 className="section-title">
            The moments
            <br />
            behind the work.
          </h2>
        </div>
        <p className="section-copy">
          A visual journal of learning, teamwork, community and the experiences
          that continue to shape my perspective.
        </p>
      </div>
      <div className="journey-rail">
        {years.map(({ year, activities }) => (
          <div className="journey-year" key={year}>
            <div className="journey-label">
              <span>{year}</span>
              <i />
            </div>
            <div className="journey-items">
              {activities.map((item, index) => (
                <motion.article
                  className={`journey-card panel journey-card-${index % 3}`}
                  key={item.title}
                  initial={{ y: 14 }}
                  whileInView={{ y: 0 }}
                  viewport={{ once: true, margin: "0px 0px 280px 0px" }}
                  transition={{
                    duration: 0.35,
                    delay: Math.min(index * 0.04, 0.2),
                  }}
                >
                  <div className="journey-image">
                    <ProgressiveImage src={item.image} alt={item.title} />
                    <span>{String(index + 1).padStart(2, "0")}</span>
                  </div>
                  <div className="journey-content">
                    <h3>{item.title}</h3>
                    <p>{item.description}</p>
                  </div>
                </motion.article>
              ))}
            </div>
          </div>
        ))}
      </div>
      <button
        className="button-secondary journey-button"
        onClick={toggleExpanded}
      >
        {expanded ? (
          <>
            <FaArrowUp /> Show less
          </>
        ) : (
          <>
            <FaArrowDown /> Explore full journey
          </>
        )}
      </button>
    </section>
  );
};

export default Activities;
